import React from 'react';
import Icon from '@ant-design/icons';

import Scale from './scale.svg';
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const ScaleIcon = (props: IconComponentProps) => <Icon component={Scale} {...props} />;
